import { Icons } from '@/components/icons';
import {
  defaultNumberFilter,
  defaultSelectFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import { CommonAreaConfig } from '@pigello/pigello-matrix';
import baseFilters, {
  baseAddressFilters,
  baseBuildingFilter,
  baseGlobalRealEstatesFilter,
  baseOutdoorAreaFilter,
  baseTagFilter,
} from '../filters';

const commonAreaFilters: Filter[] = [
  ...baseBuildingFilter,
  ...baseOutdoorAreaFilter,
  ...baseGlobalRealEstatesFilter,
  {
    ...defaultSelectFilter,
    title: CommonAreaConfig.fields.category.verboseName,
    externalFieldName: CommonAreaConfig.fields.category.externalFieldName,
    choices: CommonAreaConfig.fields.category.choices,
  },
  {
    ...defaultStringFilter,
    title: CommonAreaConfig.fields.popularName.verboseName,
    externalFieldName: CommonAreaConfig.fields.popularName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: CommonAreaConfig.fields.landlordCustomId.verboseName,
    externalFieldName:
      CommonAreaConfig.fields.landlordCustomId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultStringFilter,
    title: CommonAreaConfig.fields.customId.verboseName,
    externalFieldName: CommonAreaConfig.fields.customId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultNumberFilter,
    title: CommonAreaConfig.fields.usableArea.verboseName,
    externalFieldName: CommonAreaConfig.fields.usableArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: CommonAreaConfig.fields.biArea.verboseName,
    externalFieldName: CommonAreaConfig.fields.biArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: CommonAreaConfig.fields.temperedArea.verboseName,
    externalFieldName: CommonAreaConfig.fields.temperedArea.externalFieldName,
  },

  ...baseAddressFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default commonAreaFilters;
